<template>
    <c-modal @close="close" :title="'Afronden tolkdienst (' + request.type_aanwezigheid + ')'">
        <p>Laat je opdracht aftekenen en stuur deze door naar de planning</p>

        <c-form ref="form" :autocomplete="'off'" @valid="submit">
            <c-form-element
                :label="'Aankomsttijd'"
                :horizontal="true">
                <c-timepicker :name="'arrivaltime'" :required="true" v-model="aankomstijd"></c-timepicker>
            </c-form-element>

            <c-form-element
                :label="'Begintijd'"
                :horizontal="true">
                <c-timepicker :name="'starttime'" :required="true" v-model="begintijd"></c-timepicker>
            </c-form-element>

            <c-form-element
                :label="'Eindtijd'"
                :horizontal="true">
                <c-timepicker :name="'endtime'" :required="true" v-model="eindtijd"></c-timepicker>
            </c-form-element>
            <c-form-element
                v-if="request.type_aanwezigheid == 'Fysiek'"
                :label="'Paraaf ' + user.name"
                :horizontal="true">
                    <c-signature ref="signature_user"></c-signature>
            </c-form-element>
            <c-form-element
                v-if="request.type_aanwezigheid == 'Fysiek'"
                :label="'Paraaf gespreksvoerder'"
                :horizontal="true">
                    <c-signature ref="signature_interviewer"></c-signature>
            </c-form-element>
            <c-form-element
                v-if="request.type_aanwezigheid == 'Fysiek'"
                :label="'Wilt u dat SIGV contact met u opneemt?'"
                :horizontal="true">
                <c-radio :required="true" :name="'signature-contact'" v-model="contact_opnemen" :options="[
                    {label:'Ja', value:1},
                    {label:'Nee', value:0}
                    ]"></c-radio>
            </c-form-element>

            <div class="c-modal__btn">
                <input type="submit" class="c-btn c-btn--secondary no-margin" value="Versturen"/>
            </div>

        </c-form>
    </c-modal>
</template>
<script>
import CModal from '@components/Modal';
import CSignature from '@components/form/Signature';
import Form from '@mixins/Form';

import { mapState } from 'vuex';

export default {
    components: { CModal, CSignature },
    mixins: [ Form ],
    props: {
        request: {
            required: true
        }
    },
    data() {
        return {
            aankomstijd: '',
            begintijd: '',
            eindtijd: '',
            contact_opnemen: 0
        }
    },
    methods: {
        close() {
            if (this.request.type_aanwezigheid == 'Fysiek') {
                this.$refs.signature_user.clear();
                this.$refs.signature_interviewer.clear();
            }
            this.$refs.form.reset();

            this.aankomstijd = '';
            this.begintijd = '';
            this.eindtijd = '';
            this.contact_opnemen = false;

            this.$emit('close');
        },
        submit() {

            let submitData = {
                aankomstijd: this.aankomstijd,
                begintijd: this.begintijd,
                eindtijd: this.eindtijd,
            };
            if (this.request.type_aanwezigheid == 'Fysiek') {
                Object.assign(submitData, {
                    contact_opnemen: this.contact_opnemen,
                    paraaf_opdractnemer: this.$refs.signature_user.signature(),
                    paraaf_gesprekspartner: this.$refs.signature_interviewer.signature()
                });
            }
            this.$emit('submit', submitData);

            this.close();
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.user.data
        })
    }
}
</script>
